import { sample } from 'effector'
import { register } from '~/core/repository'
import { model as router } from '~/core/router'
import { profilesModel } from '~/entities/profiles'
import { model as sessionModel } from '~/entities/session'
import { model as subscriber } from '~/entities/subscriber'
import { appearanceFeature } from '~/features/appearance'
import { portalRedirectModel } from '~/features/portal/redirect'
import { model as guestModel } from '~/features/subscriber/guest'
import { noop } from '~/shared/effector'
import { aye, nay } from '~/shared/helpers'
import { $actualSelectedModule, selectModule } from './select'
import { $navbarDropDownTitles, $navbarStaticTitles } from './translations'

// modules to be shown in navbar (title already resolved in appearance)
export const $modules = appearanceFeature.$modules.map((modules) => {
  if (modules == null) return null
  return modules.map((mod) => ({
    ...mod,
    link: `/modules/${mod.identifier}`,
  }))
})

export const $libraryModuleLink = $modules.map(
  (modules) =>
    modules?.find(
      (m) => m.identifier === 'library' || m.identifier === 'my_list'
    )?.link ?? '/modules/library'
)

export const $signInHref = router.$href.map(
  (href) => '/sign-in' + (href && href !== '/' ? '/~' + href : '')
)

//update list of profiles after reload page
sample({
  clock: sessionModel.$session,
  source: {
    profiles: profilesModel.$optimisticProfiles,
    toaAccepted: sessionModel.$toaAccepted,
    isGuest: guestModel.$guest,
    activeProfile: profilesModel.$activeProfile,
  },
  filter: ({ profiles, toaAccepted, isGuest, activeProfile }, session) =>
    nay(profiles.length) &&
    aye(session) &&
    aye(toaAccepted) &&
    nay(isGuest) &&
    aye(activeProfile),
  fn: noop,
  target: profilesModel.getProfilesSummaryFx,
})

register($signInHref, '$navbar/signInHref')
register(profilesModel.$activeProfile, '$navbar/activeProfile')
register(profilesModel.$optimisticProfiles, '$navbar/profiles')
register($navbarStaticTitles, '$navbarStaticTitles')
register($navbarDropDownTitles, '$navbarDropDownTitles')
register(subscriber.$subscriber, '$subscriberInfo')
register(
  portalRedirectModel.openAccountSettingsModal,
  'openAccountSettingsModal'
)
register(
  portalRedirectModel.$subscriberAccountSettingsURL,
  '$subscriberAccountSettingsURL'
)
register(selectModule, 'navbar/select')
register($actualSelectedModule, '$navbar/selected')
// module customization data
register($modules, '$navbar/modules')
register($libraryModuleLink, '$navbar/libraryModuleLink')
